<template>
  <div>
    <div class="header-navbar-shadow"></div>
    <nav class="header-navbar main-header-navbar navbar-expand-lg navbar navbar-with-menu fixed-top ">
      <div class="navbar-wrapper">

        <div class="navbar-container content" style="float: right;">

          <div class="navbar-collapse " id="navbar-mobile">
            <!-- toggle to expand and compress the side bar -->
            <a class="nav-link nav-menu-main menu-toggle hidden-xs icon-spacing d-xl-none" href="#"><em
                class="ficon bx bx-menu "></em></a>
            <!-- ending toggle to expand and compress the side bar -->
            <div class="float-left bookmark-wrapper d-flex align-items-center">
              <ul class="nav navbar-nav box-right">
                <ul class="nav navbar-nav bookmark-icons">
                  <li class="dropdown dropdown-language nav-item">
                    <a class="dropdown-toggle nav-link" id="dropdown-flag" href="#" data-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <em class="flag-icon"
                        :class="($store.state.language.language === 'English') ? 'flag-icon-us' : 'flag-icon-sa'"></em><span
                        class="selected-language" style="font-style: 13px">{{ $store.state.language.language.toUpperCase() }}</span>
                    </a>
                    <div class="dropdown-menu" aria-labelledby="dropdown-flag">
                      <a class="dropdown-item" href="#" data-language="en" @click="setLanguage('English')">
                        <em class="flag-icon flag-icon-us mr-50"></em> {{$t('en_language_users')}}
                      </a>
                    </div>
                  </li>
                </ul>
              </ul>
              <ul class="nav navbar-nav">
                <li class="nav-item d-none d-lg-block">
                  <div class="bookmark-input search-input">
                    <div class="bookmark-input-icon"><em class="bx bx-search primary"></em></div>
                    <input class="form-control input" type="text" :placeholder="$t('explore_topbar')" tabindex="0"
                      data-search="template-search">
                    <ul class="search-list"></ul>
                  </div>
                </li>
              </ul>
            </div>
<div class="cursor-pointer">
  <font-awesome-icon icon="fa-solid fa-bell" />
  <font-awesome-icon class="messageIcon" icon="fa-solid fa-comments" />
</div>


            <ul class="nav navbar-nav float-right">
              <li class="dropdown dropdown-user nav-item"><a class="dropdown-toggle nav-link dropdown-user-link"
                  href="#" data-toggle="dropdown">
                  <div class="user-nav d-sm-flex d-none"><span class="user-name">{{user.name}}</span><span
                      class="user-status text-muted capitalize">{{ user.type }}</span></div>
                  <span>
                    <div class="custom-avatar">
                      <span class="avatar-name">{{ avatar.toUpperCase() }}</span>
                    </div>
                  </span>
                </a>
                <div class="dropdown-menu dropdown-menu-right pb-0">
                  <a class="dropdown-item" style="cursor: pointer;" @click="goProfile()">
                    <em class="bx bx-user mr-50"></em> {{$t('Profile')}}
                  </a>
                  <div class="dropdown-divider mb-0"></div>
                  <a class="dropdown-item" href="#" @click="logout()"><em class="bx bx-power-off mr-50"></em> {{$t('logout_topbar')}}</a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { loadLocaleMessages, languageSelector } from '../i18n';
export default {
  name: 'Topbar',

  data() {
    return {
      user: this.$store.state.currentUser.user
    }
  },

  computed: {
    avatar() {
      let user = this.user
      let name = user.name.split(' ')[0]
      let surname = user.name.split(' ')[1]
      if (surname) {
        return name[0] + surname[0]
      } else {
        if (name[1]) {
          return name[0] + name[1]
        } else {
          return name[0]
        }
      }
    },
  },

  methods: {
    logout() {
      location.href = '/logout'
    },

    goProfile() {
      $("#nav-item-sidebar-profile").click()
      this.$router.push({ name: 'ProfilePage' })
    },

    setLanguage(lang) {
      this.$store.dispatch('language/setLanguage', lang);
      this. $router.go()
    }
  }
}
</script>

<style scoped>
.custom-avatar {
  position: relative;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  background-color: #FF8302;
}

.avatar-name {
  margin-top: 1px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
  color: #fff;
}

.navbar-nav {
  padding-left: 20px !important;
}

.box-right {
  float: right;
}

.icon-spacing {
  margin-right: 561px;
}

.messageIcon{
  margin-left: 1.5em;
  height: 1em;
}
</style>
